export const heroData = {
  title: "开云体育 官方正版APP",
  subtitle: "畅享海量体育赛事 · 实时赔率 · 安全存取款 · 专属会员福利",
  ctaText: "立即下载",
  secondaryCtaText: "了解更多",
  iosBadge: "App Store 下载",
  androidBadge: "Android 下载",
};

export const featuresData = [
  {
    icon: "ri-live-line",
    title: "赛事直播",
    description: "覆盖全球各大体育赛事，高清流畅直播，绝不错过任何精彩瞬间。足球、篮球、网球、电竞等热门项目一应俱全。",
  },
  {
    icon: "ri-line-chart-line",
    title: "实时赔率",
    description: "毫秒级赔率更新，精准市场数据，助您把握每一个投注时机。多玩法赔率对比，让您的决策更加明智。",
  },
  {
    icon: "ri-shield-check-line",
    title: "安全可靠",
    description: "采用国际顶尖加密技术，资金安全保障。合法持牌经营，用户信息严格保密，存取款快速到账。",
  },
  {
    icon: "ri-vip-crown-line",
    title: "会员专属",
    description: "注册即享VIP会员权益，专属客服一对一服务，丰厚首存优惠、返水奖励及生日礼遇等您来领。",
  },
  {
    icon: "ri-smartphone-line",
    title: "多端兼容",
    description: "完美适配iOS与Android系统，手机版界面简洁流畅，随时随地畅享体育投注乐趣，操作便捷不卡顿。",
  },
  {
    icon: "ri-customer-service-2-line",
    title: "全天客服",
    description: "7×24小时专业客服团队在线，多语言支持，即时响应。任何问题都能得到快速专业的解答与处理。",
  },
];

export const categoriesData = [
  { id: "football", name: "足球", icon: "ri-football-line", color: "primary", count: 128 },
  { id: "basketball", name: "篮球", icon: "ri-basketball-line", color: "accent", count: 86 },
  { id: "tennis", name: "网球", icon: "ri-base-station-line", color: "secondary", count: 54 },
  { id: "esports", name: "电竞", icon: "ri-gamepad-line", color: "primary", count: 72 },
  { id: "baseball", name: "棒球", icon: "ri-base-station-line", color: "accent", count: 31 },
  { id: "other", name: "其他", icon: "ri-more-line", color: "secondary", count: 45 },
];

export const hotArticlesData = [
  {
    id: 1,
    title: "2026世界杯预选赛亚洲区最新战报：中国队2-1力克日本队",
    summary: "在刚刚结束的2026年世界杯亚洲区预选赛中，中国男足在主场以2比1战胜日本队，取得了关键的三分。本场比赛中国队展现出了顽强的斗志和出色的战术执行力。",
    category: "足球",
    categorySlug: "football",
    imageUrl: "https://readdy.ai/api/search-image?query=Professional%20soccer%20match%20action%20shot%20with%20players%20celebrating%20goal%20on%20green%20pitch%2C%20dramatic%20stadium%20lighting%2C%20warm%20golden%20hour%20tones%2C%20cinematic%20depth%20of%20field%2C%20editorial%20sports%20photography%20quality%2C%20clean%20composition%20with%20strong%20contrast%20and%20atmospheric%20mood&width=800&height=500&seq=hot-article-01&orientation=landscape",
    date: "2026-08-07",
    views: 12580,
  },
  {
    id: 2,
    title: "NBA夏季联赛精彩回顾：新秀球员表现亮眼",
    summary: "NBA夏季联赛落下帷幕，多位新秀在比赛中展现出令人瞩目的天赋。从得分能力到防守意识，这届新秀的整体素质令人期待他们在常规赛中的表现。",
    category: "篮球",
    categorySlug: "basketball",
    imageUrl: "https://readdy.ai/api/search-image?query=Dynamic%20basketball%20game%20action%20with%20player%20dunking%20on%20indoor%20court%2C%20dramatic%20arena%20lighting%20with%20spotlight%20effects%2C%20warm%20golden%20tones%2C%20cinematic%20sports%20photography%2C%20clean%20composition%20with%20strong%20contrast&width=800&height=500&seq=hot-article-02&orientation=landscape",
    date: "2026-08-06",
    views: 9832,
  },
  {
    id: 3,
    title: "温网决赛巅峰对决：德约科维奇再创历史",
    summary: "温布尔登网球锦标赛男单决赛上演经典对决，德约科维奇经过五盘苦战最终夺冠，刷新个人大满贯冠军纪录，再次证明了他在草地赛场的统治力。",
    category: "网球",
    categorySlug: "tennis",
    imageUrl: "https://readdy.ai/api/search-image?query=Professional%20tennis%20player%20serving%20on%20grass%20court%20under%20bright%20sunlight%2C%20Wimbledon%20style%20atmosphere%2C%20warm%20golden%20hour%20tones%2C%20cinematic%20depth%20of%20field%2C%20editorial%20sports%20photography%2C%20clean%20composition&width=800&height=500&seq=hot-article-03&orientation=landscape",
    date: "2026-08-05",
    views: 7654,
  },
  {
    id: 4,
    title: "LPL夏季赛总决赛：JDG vs BLG巅峰对决前瞻",
    summary: "英雄联盟职业联赛夏季赛总决赛即将打响，JDG与BLG两支顶级战队将展开激烈角逐。本文为您详细分析两队的战术打法、核心选手状态以及胜负关键点。",
    category: "电竞",
    categorySlug: "esports",
    imageUrl: "https://readdy.ai/api/search-image?query=Epic%20esports%20arena%20with%20massive%20LED%20screens%20and%20colorful%20stage%20lighting%2C%20gaming%20tournament%20atmosphere%2C%20dark%20background%20with%20vibrant%20pink%20and%20gold%20accents%2C%20cinematic%20wide%20shot%2C%20clean%20composition%20with%20dramatic%20contrast&width=800&height=500&seq=hot-article-04&orientation=landscape",
    date: "2026-08-04",
    views: 11230,
  },
  {
    id: 5,
    title: "开云体育投注技巧指南：新手如何提高胜率",
    summary: "想要在体育投注中获得稳定收益？本文将为您详细介绍体育投注的基本策略、资金管理方法和赛事分析方法，帮助新手玩家快速入门并提升投注水平。",
    category: "其他",
    categorySlug: "other",
    imageUrl: "https://readdy.ai/api/search-image?query=Modern%20minimalist%20sports%20analytics%20dashboard%20with%20data%20charts%20and%20statistics%20displayed%20on%20screen%2C%20warm%20golden%20ambient%20lighting%2C%20professional%20workspace%20setting%2C%20clean%20composition%20with%20strong%20contrast%20and%20editorial%20quality&width=800&height=500&seq=hot-article-05&orientation=landscape",
    date: "2026-08-03",
    views: 15678,
  },
  {
    id: 6,
    title: "MLB赛季中期盘点：各队争冠形势分析",
    summary: "美国职业棒球大联盟赛季过半，各支球队的争冠形势逐渐明朗。本文为您全面分析各分区的竞争格局、关键球员表现以及季后赛前景预测。",
    category: "棒球",
    categorySlug: "baseball",
    imageUrl: "https://readdy.ai/api/search-image?query=Professional%20baseball%20batter%20swinging%20at%20pitch%20in%20packed%20stadium%2C%20dramatic%20evening%20lighting%20with%20stadium%20floodlights%2C%20warm%20golden%20tones%2C%20cinematic%20sports%20photography%2C%20clean%20composition%20with%20strong%20contrast&width=800&height=500&seq=hot-article-06&orientation=landscape",
    date: "2026-08-02",
    views: 4321,
  },
];

export const faqData = [
  {
    question: "开云体育APP是否免费下载？",
    answer: "开云体育APP完全免费下载安装，不收取任何下载费用。您可以通过官方网站或官方应用商店免费获取最新版本，享受全部功能。",
  },
  {
    question: "开云体育支持哪些操作系统？",
    answer: "开云体育APP全面支持iOS和Android两大主流操作系统。iOS用户可通过App Store或官网下载，Android用户可通过官网直接下载APK安装包，兼容市面上绝大多数手机型号。",
  },
  {
    question: "如何注册开云体育账号？",
    answer: "下载安装开云体育APP后，打开应用点击「注册」按钮，按照提示填写手机号码、设置密码并完成短信验证即可成功注册。整个过程仅需1-2分钟，简单快捷。",
  },
  {
    question: "开云体育存取款安全吗？",
    answer: "开云体育采用国际领先的SSL加密技术和多重安全防护体系，所有资金交易均经过严格加密处理。平台持有正规经营牌照，用户资金与平台运营资金严格分离，确保您的资金安全无忧。",
  },
  {
    question: "开云体育的最低投注金额是多少？",
    answer: "开云体育最低投注金额为10元起，不同赛事和玩法的最低投注限额可能略有差异。平台设有完善的限额机制，倡导理性投注，保护用户权益。",
  },
  {
    question: "开云体育APP如何更新到最新版本？",
    answer: "当有新版本发布时，开云体育APP会自动推送更新提示。您也可以定期访问官方网站下载最新版本安装包，手动覆盖安装即可完成更新，确保体验最新功能和安全优化。",
  },
];

export const downloadStepsData = [
  {
    step: 1,
    title: "访问官网",
    description: "通过浏览器访问开云体育官方网站，或扫描二维码进入下载页面。",
    icon: "ri-global-line",
  },
  {
    step: 2,
    title: "选择版本",
    description: "根据您的手机系统选择iOS版或Android版，点击对应的下载按钮。",
    icon: "ri-download-2-line",
  },
  {
    step: 3,
    title: "安装APP",
    description: "下载完成后按照提示完成安装，Android用户需开启「允许安装未知来源应用」。",
    icon: "ri-install-line",
  },
  {
    step: 4,
    title: "注册登录",
    description: "打开APP完成注册并登录，即可畅享开云体育全部功能与服务。",
    icon: "ri-user-add-line",
  },
];